import styled from "@emotion/styled";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type {
  ContentSchemaRenderProps,
  RenderComponent,
} from "~/components/content/content-schema-render";
import type { blockquoteQuoteContent$key } from "~/queries/__generated__/blockquoteQuoteContent.graphql";

import {
  StyledBlockquote,
  StyledContentShareWidget,
  StyledFigcaption,
  StyledFigure,
  StyledFooter,
  StyledQuoteIcon,
} from "./styles";

type Props = {
  reference: blockquoteQuoteContent$key;
} & ContentSchemaRenderProps;

const Component: FunctionComponent<Props> = ({ reference: reference_, schemaNode }) => {
  const content = useFragment(
    graphql`
      fragment blockquoteQuoteContent on Content {
        ...contentShareWidgetContent
      }
    `,
    reference_,
  );

  const [quoteNode, sourceNode] = schemaNode.children ?? [];

  return (
    <StyledFigure>
      <StyledQuoteIcon />
      <StyledBlockquote>{quoteNode?.data}</StyledBlockquote>
      <StyledFigcaption>{sourceNode?.data}</StyledFigcaption>
      <StyledFooter>
        <StyledContentShareWidget
          customGATracking={{
            category: "Share button (block quote)",
          }}
          position="block_quote"
          reference={content}
          style={{ backgroundColor: "transparent", color: "#001246" }}
          types={["facebook", "twitter", "email"]}
        />
      </StyledFooter>
    </StyledFigure>
  );
};

Component.displayName = "BlockquoteQuote";

export const BlockquoteQuote: RenderComponent = styled(Component)``;
BlockquoteQuote.isHandlingOwnChildren = true;
